import React from 'react'
import { PersistGate } from 'zustand-persist'

import PaginatedJournals from './Components/PaginatedJournals'
import Filters from './Components/Filters'
import { useStore } from './Store/useStore'
import { countJournalsInFilters } from './Utilities/filterUtility'

/**
 * The overview for the journals including filtering.
 *
 * @author    Anian Weber <a.weber@techdivision.com>
 * @copyright 2021 TechDivision GmbH <info@techdivision.com>
 */
export const App = () => {
    const allFilters = useStore((state) => state.allFilters)
    const allJournals = useStore((state) => state.allJournals)
    // Count the journals once on initialization of the app
    countJournalsInFilters(allJournals, allFilters)

    return (
        <PersistGate>
            <Filters className="journal-list__filter-list--sticky" />
            <PaginatedJournals className="journal-list__result" />
        </PersistGate>
    )
}
